import React, { useEffect, useRef, useState } from 'react';
import { Row, Col, Card } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { DefaultButton, IconButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { useBoolean } from '@fluentui/react-hooks';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import { _global_buttonStyles, __OBJECT_STRUCTURE_GetList } from '../../common/ObjectStructures/Trasnversal';
import AddForm from './AddForm';
import PropTypes from 'prop-types';
import EditForm from './EditForm';

const SidePanelConfigure = (props) => {
    const { t } = useTranslation();
    
    
    
    const { 
        inputParam_IsPanelOpen = null, 
        inputParam_SetterIsPanelOpen = null,     
        item_data = null    
    } = props;
    
    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    



    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen(false);
       
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
    };


    const onClosePanel = () => {
        onDismissPanel();
    };
    const onSaveConfiguration = () => {
        onDismissPanel();
    };

    
    const editFormRef = useRef(null);
    
    

  const handleSaveButtonClick = () => {
    // Llama al método handleFormSubmit de AddForm
    if (editFormRef) {        
        editFormRef.current.handleFormSubmit();
    }
  };

    const onRenderFooterContent = () => {
        return  <Row>
                    <Col xl={12} className="message-verybottom-panel-medium">
                        Mensajes
                    </Col>
                    <Col xl={12}>
                        <PrimaryButton onClick={handleSaveButtonClick} styles={_global_buttonStyles}>{ t('data-lang-btn-save') }</PrimaryButton>                        
                        <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-cancel') }</DefaultButton>
                    </Col>
                </Row>
    }

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText="editing"
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                <EditForm preSetData={item_data} ref={editFormRef} ></EditForm>
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
};

SidePanelConfigure.propTypes = {
    inputParam_IsPanelOpen: PropTypes.bool.isRequired,  
    inputParam_SetterIsPanelOpen: PropTypes.func.isRequired,      
};

export default SidePanelConfigure;